<template>
  <div class="material-category">
    <div class="material-category__list" ref="list">
      <button
        type="button"
        @click="handleClick(item)"
        v-for="item in list"
        :key="item.id"
        class="material-category__item"
        :class="{ 'material-category__item--active': item.id === selected }"
      >
        {{ item.cn_name }}
      </button>
    </div>
    <a-button
      type="link"
      block
      size="small"
      class="material-category__toggle"
      @click="toggleCollapse"
      v-show="showingMore"
      :icon="collapsed ? 'down' : 'up'"
    >
      {{ collapsed ? "展开" : "收起" }}
    </a-button>
  </div>
</template>
<script>
export default {
  props: ['list', 'selected', 'collapsed'],
  mounted() {
    this.handleCollapse();
  },
  computed: {
    showingMore() {
      return this.list && this.list.length > 3;
    },
    usedHeight() {
      const rows = Math.ceil(this.list.length / 3);
      return this.collapsed ? 24 : Math.max(24, rows * 32 - 8);
    },
    heightMarker() {
      return [this.usedHeight, this.showingMore].join(',');
    }
  },
  methods: {
    toggleCollapse() {
      this.$emit('update:collapsed', !this.collapsed);
    },
    handleCollapse() {
      const list = this.$refs.list;
      const height = this.usedHeight + (this.showingMore ? 36 : 12);
      list.style.height = this.usedHeight + 'px';
      this.$emit('update:height', height);
    },
    handleClick(item) {
      this.$emit('itemClick', item);
    }
  },
  watch: {
    heightMarker() {
      this.handleCollapse();
    }
  }
}
</script>
<style scoped>
.material-category {
  overflow: hidden;
  font-size: 12px;
  position: relative;
  margin: 12px 0 4px;
}

.material-category__list {
  display: flex;
  overflow: hidden;
  margin-right: -8px;
  flex-wrap: wrap;
  transition: 0.2s;
  align-items: flex-start;
  align-content: flex-start;
  height: 24px;
}

.material-category__item {
  padding: 2px 0;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  margin: 0 8px 8px 0;
  transition: 0.3s;
  width: calc(33% - 8px);
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.material-category__item:hover,
.material-category__item:focus {
  border-color: #40a9ff;
  color: #40a9ff;
}

.material-category__item--active {
  color: #fff;
  background-color: #1890ff;
  border-color: #1890ff;
}

.material-category__item--active:hover,
.material-category__item--active:focus {
  color: #fff;
  background-color: #40a9ff;
}

.material-category__toggle {
  display: block;
  margin-top: 4px;
  font-size: 100%;
}

.material-category__toggle ::-v-deep .anticon {
  font-size: 14px;
}
</style>